import BaseComponent from './base_component';
import { ToasterHandler } from '../services/toaster/toaster_handler';
import IToasterOptions from '../services/toaster/toaster_options_interface';
import _ from '../utils/underscore';

export default class ToasterBaseComponent extends BaseComponent {
    static CLASS = 'ToasterBaseComponent';

    protected _toasterHandler: ToasterHandler = null;

    showAsToaster(options: IToasterOptions = {}) {
       
        const mergedOptions: IToasterOptions = {...options};

        const merge2Func = (fn1: () => void, fn2?: () => void) => {
            return () => {
                if (_.isFunction(fn1)) {
                    fn1();
                }
                if (_.isFunction(fn2)) {
                    fn2();
                }
            };
        };

        mergedOptions.onOpened = merge2Func(this._onOpened.bind(this), options.onOpened);
        mergedOptions.onClosed = merge2Func(this._onClosed.bind(this), options.onClosed);
        mergedOptions.onClicked = merge2Func(this._onClicked.bind(this), options.onClicked);

        this._toasterHandler = this.serviceFactory.toasterService().showToasterFromComponent(this, mergedOptions);
    }

    closeToaster() {
        if (this._toasterHandler) {
            this._toasterHandler.close();
        }
    }

    protected _onOpened() {
    }

    protected _onClicked() {
    }

    protected _onClosed() {
    }
}
